import { fetchError, fetchStart, fetchSuccess } from "../../redux/actions";
import axios from "../auth/jwt/config";
import {
  setAllForms,
  setformTotalpages,
  setformCurrentpage,
  deleteForm,
  setSingleForm,
  setFillForms,
  setFillFormsCurrentPage,
  setFillFormsTotalPages,
  removeSingleFormFilled,
  setSingleFormFill,
  setFillFormToatalDocs,
} from "redux/actions/FormBuilder";

const FormRequests = {
  createForm: (formData) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .post(`/form/create`, formData)
          .then(({ data }) => {
            dispatch(fetchSuccess("فرم با موفقیت ساخته شد"));
            dispatch(setSingleForm(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  updateForm: (formData, id) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .post(`/form/update/${id}`, formData)
          .then(({ data }) => {
            dispatch(setSingleForm(data));
            dispatch(fetchSuccess("فرم با موفقیت به‌روزرسانی شد"));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getForms: (page) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/form/getall?page=${page}&limit=10`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setAllForms(data.docs));
            dispatch(setformCurrentpage(data.page));
            dispatch(setformTotalpages(data.totalPages));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getFormById: (id) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/form/get/${id}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setSingleForm(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  deleteForm: (formId) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/form/remove/${formId}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت حذف شد"));
            dispatch(deleteForm(formId));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getFillForms: (formId, page, searchStr) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(
            `/formfilled/getall/${formId}?page=${page}&limit=10&searchString=${searchStr}`
          )
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setFillForms(data.docs));
            dispatch(setFillFormsCurrentPage(data.page));
            dispatch(setFillFormsTotalPages(data.totalPages));
            dispatch(setFillFormToatalDocs(data.totalDocs));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  removeSingleFillForm: (formId, totalItems, currentPage) => {
    return (dispatch) => {
      try {
        axios
          .delete(`/formfilled/remove/${formId}`)
          .then(() => {
            dispatch(removeSingleFormFilled(formId));
            if (totalItems < 2) {
              if (currentPage !== 1) {
                FormRequests.getFillForms(currentPage - 1)(dispatch);
              }
            }
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  getFillForm: (fillId) => {
    return (dispatch) => {
      try {
        dispatch(fetchStart());
        axios
          .get(`/formfilled/getsingle/${fillId}`)
          .then(({ data }) => {
            dispatch(fetchSuccess());
            dispatch(setSingleFormFill(data));
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msg));
            } else {
              dispatch(fetchError(error.message));
            }
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
  attendFillForm: (id) => {
    return (dispatch) => {
      try {
        axios
          .get(`/formfilled/attend/admin/${id}`)
          .then(() => {
            dispatch(fetchSuccess("با موفقیت ثبت شد"));
            setTimeout(() => {
              FormRequests.getFillForm(id)(dispatch);
            }, 3000);
          })
          .catch((error) => {
            if (error.response) {
              dispatch(fetchError(error.response.data.msgFa));
            }
            dispatch(fetchError(error.message));
          });
      } catch (error) {
        dispatch(fetchError(error.message));
      }
    };
  },
};

export default FormRequests;
